import { Link, useLocation } from "wouter";
import { Calculator, ArrowRight } from "lucide-react";

const CALC_PATH = "/roofing-siding-cost-calculator-lancaster-pa/";

export function CalculatorSlideOut() {
  const [location] = useLocation();

  if (location.startsWith(CALC_PATH.replace(/\/$/, ""))) {
    return null;
  }

  return (
    <Link
      href={CALC_PATH}
      aria-label="Open the roofing and siding cost calculator"
      data-testid="slideout-cost-calculator"
      className="group hidden md:flex fixed right-0 top-1/2 z-40 -translate-y-1/2 items-stretch overflow-hidden rounded-l-lg shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <div className="w-0 overflow-hidden bg-secondary transition-[width] duration-300 ease-out group-hover:w-60 group-focus:w-60 motion-reduce:transition-none">
        <div className="w-60 px-5 py-4 text-left">
          <div className="mb-1 font-serif text-lg font-bold leading-tight text-white">
            Estimate Your Project
          </div>
          <p className="mb-3 text-sm text-secondary-foreground/80">
            Get a ballpark price for your roofing or siding project in seconds.
          </p>
          <span className="inline-flex items-center gap-1 rounded bg-primary px-4 py-2 text-sm font-bold text-primary-foreground">
            Open Calculator <ArrowRight className="h-4 w-4" />
          </span>
        </div>
      </div>
      <div className="flex w-12 shrink-0 flex-col items-center justify-center gap-2 bg-primary py-5 text-primary-foreground">
        <Calculator className="h-5 w-5" />
        <span className="rotate-180 text-[11px] font-bold uppercase tracking-wide [writing-mode:vertical-rl]">
          Project Cost Calculator
        </span>
      </div>
    </Link>
  );
}
